'use client'

import SvgIcon from '@mui/material/SvgIcon'
import PropTypes from 'prop-types'

export const FormulaIcon = ({ sx }) => {
  return (
    <SvgIcon sx={sx} data-testid="FormulaIcon">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        id="Layer-Style--Streamline-Ultimate"
        height="24"
        width="24"
      >
        <desc>Layer Style Streamline Icon: https://streamlinehq.com</desc>
        <path
          stroke="#3d517b"
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M13.3641 2.05444c-3.47423 0 -5.47158 1.65015 -6.16646 6.68745 -0.69489 5.03731 -0.83995 6.02551 -1.2742 8.97841 -0.43425 2.9529 -2.51537 4.2251 -4.31895 4.2251"
          strokeWidth="1"
        ></path>
        <path
          stroke="#3d517b"
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M3.80762 8.30762h7.55618"
          strokeWidth="1"
        ></path>
        <path
          stroke="#3d517b"
          strokeLinecap="round"
          strokeLinejoin="round"
          d="m15.0126 8.30762 5.7321 11.29048m-8.5113 0L22.3948 8.30762"
          strokeWidth="1"
        ></path>
      </svg>
    </SvgIcon>
  )
}

FormulaIcon.propTypes = {
  sx: PropTypes.object
}
